<div class="flex">
  @for (symbol of operatorSymbols(); track $index) {
    <span class="w-6 h-6 bg-ui-gray-900 border-ui-gray-light border rounded flex items-center justify-center mr-1 font-bold text-ui-gray-100 text-2xl last:mr-0">{{ symbol }}</span>
  }
</div>
